import { Card, Stack, Typography, Box, CardContent } from '@mui/material';
import StorageIcon from '@mui/icons-material/Storage';
import PeopleIcon from '@mui/icons-material/People';
import FolderIcon from '@mui/icons-material/Folder';
import useResponsive from '../../hooks/useResponsive';

export default function StorageStatsCards({ storageStats }) {
  const mdUp = useResponsive('up', 'md');

  return (
    <Box display={mdUp ? 'flex' : ''} gap={2} marginY={3}>
      <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
        <CardContent>
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
            Total Users
          </Typography>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <PeopleIcon color="primary" />
            <Typography variant="h5">{storageStats.totalUsers}</Typography>
          </Stack>
        </CardContent>
      </Card>

      <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
        <CardContent>
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
            Total Buckets
          </Typography>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <StorageIcon color="primary" />
            <Typography variant="h5">{storageStats.totalBuckets}</Typography>
          </Stack>
        </CardContent>
      </Card>

      <Card sx={{ minWidth: 200, flex: 1, marginBottom: mdUp ? 0 : 2 }}>
        <CardContent>
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
            Assigned Buckets
          </Typography>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <FolderIcon color="success" />
            <Typography variant="h5">{storageStats.assignedBuckets}</Typography>
          </Stack>
        </CardContent>
      </Card>

      <Card sx={{ minWidth: 200, flex: 1 }}>
        <CardContent>
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
            Total Storage
          </Typography>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <StorageIcon color="warning" />
            <Typography variant="h5">{storageStats.totalStorage}</Typography>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
